import type { WallLayoutPreset, WallSide } from "@/lib/location-scene-3d/platform"
import { wallSidesForPreset } from "@/lib/location-scene-3d/platform"

/** Top-down floor plate; south = bottom, east = right (matches default NW camera far edges). */
const FLOOR = { x: 5, y: 5, w: 14, h: 14 }

type WallPresetIconProps = {
  preset: WallLayoutPreset
  className?: string
}

function wallStroke(side: WallSide): { x1: number; y1: number; x2: number; y2: number } {
  const { x, y, w, h } = FLOOR
  switch (side) {
    case "north":
      return { x1: x, y1: y, x2: x + w, y2: y }
    case "south":
      return { x1: x, y1: y + h, x2: x + w, y2: y + h }
    case "west":
      return { x1: x, y1: y, x2: x, y2: y + h }
    case "east":
      return { x1: x + w, y1: y, x2: x + w, y2: y + h }
  }
}

/** Mini top-down glyph: thick wall edges; thin floor square only for «none». */
export function WallPresetIcon({ preset, className }: WallPresetIconProps) {
  const sides = wallSidesForPreset(preset)
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" className={className} aria-hidden>
      {preset === "none" ? (
        <rect
          x={FLOOR.x}
          y={FLOOR.y}
          width={FLOOR.w}
          height={FLOOR.h}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinejoin="round"
        />
      ) : null}
      {[...sides].map((side) => {
        const line = wallStroke(side)
        return (
          <line
            key={side}
            x1={line.x1}
            y1={line.y1}
            x2={line.x2}
            y2={line.y2}
            stroke="currentColor"
            strokeWidth={2.75}
            strokeLinecap="square"
          />
        )
      })}
    </svg>
  )
}
